__turbopack_context__.v({
  "className": "newsreader_60b00d6f-module__3EvTSq__className",
});
